<template>
  <v-ons-page class="l-content l-card">
    <custom-toolbar backLabel="Retour">{{ title }}</custom-toolbar>

    <div class="container">

      <div v-for="partner in partners" :key="partner.par_id" class="partner" @click="showPartner(partner.par_id)">
        <div class="row">

          <div class="col-25">
            <div class="logo" :style="{ 'background-image': 'url(' + (partner.par_logo != '' ? url_erp + '/partners/' + partner.par_id + '/logos/' + partner.par_logo : 'img/partner_noimg.png') + ')' }"></div>
          </div>

          <div class="col-35">
            <div class="infos">
              <h2>{{ partner.par_name }}</h2>

              <div v-if="partner.par_address != ''" class="info">
                <i class="fas fa-map-marker-alt"></i>
                <div class="address ">
                  {{ partner.par_address }}
                  <br>
                  {{ partner.par_zip }} {{ partner.par_city }}
                </div>
              </div>

              <div v-if="partner.par_tel != ''" class="info">
                <i class="fas fa-phone"></i>
                  <div class="phone">
                    <a :href="'tel:' + partner.par_tel">{{ partner.par_tel }}</a>
                  </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div v-if="!partners.length">
        {{ $t("Aucun partner pour l'instant") }}
      </div>
        
    </div>

    <v-ons-modal :visible="modal_visible" class="l-modal partner">
      <i class="fa fa-times close_btn" @click="modal_visible = false"></i>

      <div v-if="modal_partner" class="container">
        <div class="logo" :style="{ 'background-image': 'url(' + (modal_partner.par_logo != '' ? url_erp + '/partners/' + modal_partner.par_id + '/logos/' + modal_partner.par_logo : 'img/partner_noimg.png') + ')' }"></div>

        <div class="infos">
          <h3>{{ partnerCategory(modal_partner) }}</h3>
          <h2>{{ modal_partner.par_name }}</h2>

          <div v-if="partnerActivity(modal_partner) != ''" class="info">
            <i class="fas fa-tag"></i>
            <span>{{ partnerActivity(modal_partner) }}</span>
          </div>

          <div v-if="partnerGift(modal_partner) != ''" class="info">
            <i class="fas fa-gift"></i>
            <span>{{ partnerGift(modal_partner) }}</span>
          </div>

          <div v-if="modal_partner.par_contact != ''" class="info">
            <i class="fas fa-user"></i>
            <span>{{ modal_partner.par_contact }}</span>
          </div>

          <div v-if="modal_partner.par_address != ''" class="info">
            <i class="fas fa-map-marker-alt"></i>
            <div class="address ">
              {{ modal_partner.par_address }}
              <br>
              {{ modal_partner.par_zip }} {{ modal_partner.par_city }}
            </div>
          </div>

          <div v-if="modal_partner.par_tel != ''" class="info">
            <i class="fas fa-phone"></i>
            <span>
              <a :href="'tel:' + modal_partner.par_tel">{{ modal_partner.par_tel }}</a>
            </span>
          </div>

          <div v-if="modal_partner.par_email != ''" class="info">
            <i class="fas fa-at"></i>
            <span>{{ modal_partner.par_email }}</span>
          </div>

          <div v-if="modal_partner.par_web != ''" class="info">
            <i class="fas fa-globe"></i>
            <span>{{ modal_partner.par_web }}</span>
          </div>

        </div>

      </div>
    </v-ons-modal>
  </v-ons-page>
</template>

<script>
  export default {
    data () {
      return {
        partners: [],
        url_erp: url_erp,
        modal_visible: false,
        modal_partner: {},
      };
    },
    methods: {
      showPartner(partner_id) {
        this.modal_visible = true;
        axios
          .get('/partners/show', {
            params: {
              'x-secundo-auth': 'ABC123',
              'partner_id': partner_id
            }
          })
          .then(response => {
            this.modal_partner = response.data;
          });
      },
      partnerActivity(partner) {
        switch(this.$i18n.locale) {
          case 'nl':
            return partner.par_activityNL;
          default:
            return partner.par_activityFR;
        }
      },
      partnerGift(partner) {
        switch(this.$i18n.locale) {
          case 'nl':
            return partner.par_giftNL;
          default:
            return partner.par_giftFR;
        }
      },
      partnerCategory(partner) {
        switch(this.$i18n.locale) {
          case 'nl':
            return partner.pac_nameNL;
          default:
            return partner.pac_nameFR;
        }
      }
    },
    created() {
      axios
        .get('/partners/list', {
          params: {
            'x-secundo-auth': 'ABC123',
            'category_id': this.category.pac_id
          }
        })
        .then(response => {
          this.partners = response.data;
        });
    }
  };
</script>


// WEBPACK FOOTER //
// PartnerCategory.vue?0d254c19